import { Link } from 'react-router-dom';
import { articlePreviews } from '@/mocks/articles';

export default function CTASection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20curated%20fashion%20retail%20display%20with%20warm%20ambient%20lighting%2C%20neatly%20arranged%20clothing%20and%20accessories%20on%20minimalist%20shelves%2C%20soft%20cream%20beige%20and%20warm%20neutral%20tones%2C%20sophisticated%20boutique%20interior%20aesthetic%2C%20no%20people%2C%20premium%20editorial%20quality%20photography%2C%20inviting%20shopping%20atmosphere&width=1400&height=600&seq=cta-bg-2026&orientation=landscape')`,
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-accent-500/85"></div>

          <div className="relative z-10 text-center px-6 py-14 md:py-16">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
              Bereit für dein nächstes OOPBuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-white/85 max-w-lg mx-auto mb-6">
              Entdecke jetzt die besten Spreadsheets und starte deinen Einkauf. Über 500 Spreadsheets und 9 Experten-Guides warten auf dich.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-7 py-3 rounded-lg text-sm font-semibold bg-white text-primary-600 hover:bg-white/95 transition-all cursor-pointer whitespace-nowrap"
              >
                OOPBuy Spreadsheet &rarr;
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-7 py-3 rounded-lg text-sm font-semibold bg-white/15 backdrop-blur-sm text-white border border-white/30 hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
              >
                Buy It Now &rarr;
              </a>
            </div>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
              {articlePreviews.slice(0, 4).map((ap) => (
                <Link
                  key={ap.slug}
                  to={`/artikel/${ap.slug}`}
                  className="text-xs text-white/70 hover:text-white hover:underline transition-all cursor-pointer whitespace-nowrap"
                >
                  {ap.category} Guide
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}